/* ── Shared Vedic sign lookups (used by the Horoscope and Kundli tabs) ──
   Sanskrit rashi names, elements and unicode glyphs keyed by the western
   sign name VedAstro returns. */
export const SIGN_SANSKRIT = {
  Aries: 'मेष राशि', Taurus: 'वृषभ राशि', Gemini: 'मिथुन राशि', Cancer: 'कर्क राशि',
  Leo: 'सिंह राशि', Virgo: 'कन्या राशि', Libra: 'तुला राशि', Scorpio: 'वृश्चिक राशि',
  Sagittarius: 'धनु राशि', Capricorn: 'मकर राशि', Aquarius: 'कुंभ राशि', Pisces: 'मीन राशि',
}
export const SIGN_ELEMENT = {
  Aries: 'Fire', Leo: 'Fire', Sagittarius: 'Fire', Taurus: 'Earth', Virgo: 'Earth', Capricorn: 'Earth',
  Gemini: 'Air', Libra: 'Air', Aquarius: 'Air', Cancer: 'Water', Scorpio: 'Water', Pisces: 'Water',
}
export const SIGN_GLYPH = {
  Aries: '♈', Taurus: '♉', Gemini: '♊', Cancer: '♋', Leo: '♌', Virgo: '♍',
  Libra: '♎', Scorpio: '♏', Sagittarius: '♐', Capricorn: '♑', Aquarius: '♒', Pisces: '♓',
}
